import React from 'react';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
import { Translate } from '@pegasus/translation';
export var SearchButton = function (_a) {
    var search = _a.search, disabled = _a.disabled, count = _a.count;
    return (React.createElement(Button, { fullWidth: true, color: ButtonColor.primary, buttonType: ButtonType.primary, onClick: search, disabled: disabled, "data-testid": "category-filter-small-screen-search-button" }, count < 10000 ? (React.createElement(Translate, { message: "filters.showResults", params: { count: count } })) : (React.createElement(Translate, { message: "filters.showResultsWithPlus" }))));
};
